<style scoped>
html {
  font-family: "Inter", sans-serif;
}
.pagination >>> li > button {
  color: rgb(0 43 106);
}

.pagination >>> li.active > button {
  color: white !important;
  background-color: rgb(0 43 106) !important;
}
.pagination >>> li > button:hover {
  color: white;
  background-color: rgb(0 43 106) !important;
}

.mt-100 {
  margin-top: 100px;
}

.loader {
  text-align: center;
}
.breadcrumb-item a {
  color: rgb(0 147 221) !important;
}
.breadcrumb-item {
  font-size: 1rem;
  font-weight: 600;
}
.breadcrumb {
  display: flex;
  box-shadow: none;
  border: none;
}
.card-header {
  background: rgb(0 43 106);
  color: white;
  padding-top: 10%;
  margin-bottom: 0px;
  margin-left: -4%;
  margin-right: -4%;
  margin-top: -4%;
  font-size: 1rem;
  font-weight: 700;
}
</style>
<template>
  <b-container
    fluid
    class="main-wrapper"
    style="
      color: black;
      padding-bottom: 5%;
      font-family: 'Inter', 'sans-serif' !important;
    "
  >
    <b-row class="ml-5 mr-5 mt-5 mb-0">
      <b-col class="ml-5 mr-5">
        <b-breadcrumb :items="breadcrumbs" class="breadcrumbs"></b-breadcrumb>
        <b-row class="mt-4">
          <b-col v-if="isLoading" cols="9">
            <b-card class="mb-4 shadow-none">
              <b-skeleton animation="wave" width="85%"></b-skeleton>
              <b-skeleton animation="wave" width="85%"></b-skeleton>
              <b-skeleton animation="wave" width="85%"></b-skeleton>
              <b-skeleton animation="wave" width="70%"></b-skeleton>
              <b-skeleton animation="wave" width="70%"></b-skeleton>
              <b-skeleton animation="wave" width="70%"></b-skeleton>
              <b-skeleton animation="wave" width="55%"></b-skeleton>
              <b-skeleton animation="wave" width="55%"></b-skeleton>
              <b-skeleton animation="wave" width="55%"></b-skeleton>
            </b-card>
          </b-col>
          <b-col v-else cols="9">
            <b-card class="mb-4 shadow-none">
              <h5 style="color: rgb(0 43 106)">{{ this.news.title }}</h5>
              <b-row>
                <b-col md="12">
                  <b-card-img
                    :src="getBase64Image(this.news.thumbnail)"
                    alt="Deskripsi Gambar"
                    class="float-end crop-image mr-4 mb-4"
                  />
                  <p>
                    <b-badge v-if="this.news.isDone" variant="primary"
                      >{{ this.news.formattedDate }} | Telah
                      Dilaksanakan</b-badge
                    >
                    <b-badge v-else variant="success"
                      >{{ this.news.formattedDate }} | Akan Datang</b-badge
                    >
                  </p>
                  <div
                    style="text-align: justify"
                    v-html="this.news.content"
                  ></div>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card>
              <template #header>
                <p>Berita dan Kegiatan Lainnya</p>
              </template>
              <b-card-text>
                <b-row
                  @click="onRowClick(item.slug)"
                  class="clickable"
                  v-for="item in otherNews"
                  :key="item.id"
                >
                  <b-col cols="4" style="padding-left: 0px; padding-right: 0px">
                    <b-img
                      class="crop-image-other"
                      fluid
                      :src="getBase64Image(item.thumbnail)"
                      alt="Left image"
                    ></b-img>
                  </b-col>
                  <b-col onclick="" cols="8" style="padding-left: 0px">
                    <small>{{ item.formattedDate }}</small>
                    <p style="color: rgb(0 60 128); font-size: 0.8rem">
                      {{ item.title }}
                    </p>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </b-col></b-row
    >
  </b-container>
</template>
<style scoped>
.crop-image {
  float: left;

  max-height: 350px; /* Atur tinggi sesuai kebutuhan */
  object-fit: cover; /* Crop gambar agar sesuai ukuran elemen */
  overflow: hidden; /* Sembunyikan bagian gambar yang keluar */
}
.crop-image-other {
  border-radius: 10px;
  width: 70px; /* Pastikan gambar memenuhi ukuran elemen */
  max-height: 80px; /* Atur tinggi sesuai kebutuhan */
  object-fit: cover; /* Crop gambar agar sesuai ukuran elemen */
  overflow: hidden; /* Sembunyikan bagian gambar yang keluar */
}
.clickable {
  cursor: pointer;
  transition: background-color 0.2s;
}
</style>
<script>
import sdiService from "../../services/SdiService";
// import vSelect from "vue-select";
// import "vue-select/dist/vue-select.css";
export default {
  name: "Data",
  props: {
    projectName: {
      type: String,
      required: false,
    },
  },
  data: () => {
    return {
      isLoading: true,
      news: {
        title: "none",
      },
      otherNews: [],
      projectFullName: "Sistem Statistik Hayati Indonesia",
      breadcrumbs: [
        {
          text: "Beranda",
          to: "/sshi",
        },
        {
          text: "Berita dan Kegiatan",
          to: "/sshi/news",
        },
        {
          text: "none",
          active: true,
        },
      ],
    };
  },
  components: {
    // vSelect,
  },
  mounted() {
    switch (this.projectName) {
      case "sshi":
        this.projectFullName = "Sistem Statistik Hayati Indoneisa";
        break;
      default:
        this.projectFullName = "Sistem Statistik Hayati Indoneisa";
    }
    this.loadData(this.$route.params.slug);
  },
  created() {
    // this.loadJenisData("jenis data");
  },
  computed: {},
  methods: {
    onRowClick(item) {
      this.$router.push("/" + this.projectName + "/news/" + item);
    },
    getBase64Image(base64) {
      // Menambahkan awalan data:image/jpeg;base64, jika Base64 tidak mengandung awalan
      const mimeType = this.getMimeType(base64);
      const fullBase64 = `data:${mimeType};base64,${base64}`;
      return fullBase64;
    },
    getMimeType(base64) {
      // Cek tipe MIME dari Base64 string, bisa dikembangkan lebih lanjut
      if (base64.startsWith("iVBOR")) {
        return "image/png"; // Jika Base64 string diawali dengan 'iVBOR' berarti PNG
      } else if (base64.startsWith("/9j/")) {
        return "image/jpeg"; // Jika Base64 string diawali dengan '/9j/' berarti JPEG
      }
      return "image/jpeg"; // Default ke JPEG jika tidak diketahui
    },
    async loadData(slug) {
      await sdiService.getNewsDetail(slug).then(
        (response) => {
          this.news = response.data;
          this.news.content = this.news.content
            .replace("<br>", "")
            .replace("<p><br></p>", "");
          this.news.isDone =
            new Date() > new Date(this.news.doneAt) ? true : false;
          this.news.formattedDate = new Intl.DateTimeFormat("id-ID", {
            day: "numeric",
            month: "long",
            year: "numeric",
          }).format(new Date(this.news.postAt));
          this.breadcrumbs[2].text = response.data.title.slice(0, 100);
        },
        (error) => {
          console.log(error);
        }
      );
      await sdiService.getNews(0, 6, this.projectName, "").then(
        (response) => {
          // console.log(response);
          this.otherNews = response.data.content;
          this.isLoading = false;
        },
        (error) => {
          console.log(error);
        }
      );
    },
  },
  watch: {
    "$route.params.slug": {
      handler(slug) {
        this.loadData(slug); // Load data baru berdasarkan parameter
      },
      immediate: true, // Jalankan juga saat komponen pertama kali di-mount
    },
  },
};
</script>
